/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Persist one in-progress MCQ answer selection.
 */
export interface MCQAnswerUpdateRequest {
  questionId: string;
  optionId: string;
}
